import Minze, { Attrs, EventListeners, MinzeElement } from 'minze'

export interface LvcSuccessScreen {
  iconSize: string
  dataId: string
  dataTitle: string
  dataText: string
  dataButton: string
}

export class LvcSuccessScreen extends MinzeElement {
  attrs: Attrs = [['data-id'], ['data-title'], ['data-text'], ['data-button']]

  onReady(): void | Promise<void> {}

  onClickPrimaryButton() {
    Minze.cast(`lvc:success-screen-primary-button-click:${this.dataId}`)
  }

  html(): string {
    let mobile = window.innerWidth < 960

    let titleSize = mobile ? 'titleMobileSmall' : 'titleDesktopSmall'
    let messageSize = mobile ? 'medium' : 'large'
    this.iconSize = mobile ? '300px' : '400px'
    return `

        <div class="container">
          <lvc-box class="icon">
            <lvc-charlie-peacesign-icon width="${this.iconSize}" height="${this.iconSize}"></lvc-charlie-peacesign-icon>
          </lvc-box>
          <lvc-box class="title">
            <lvc-text font-preset=${titleSize} class="lvc-modal-title">${this.dataTitle}</lvc-text>
          </lvc-box>
          <lvc-box class="message">
            <lvc-text font-preset=${messageSize} class="lvc-modal-title">${this.dataText}</lvc-text>
          </lvc-box>
          <lvc-box class="buttonContainer">
            <lvc-button enable-hover-box-shadow="true" width="${window.matchMedia(' (max-width: 730px)').matches ? '100%' : 'fit-content'}" class="button"
                height="100%" width="100%" font-size="1rem" font-weight="500" padding="14px 24px" name="primaryButton" > ${this.dataButton} </lvc-button>
          </lvc-box>
        </div>
  `
  }

  css() {
    return `
    .container {
        text-align: center;
      }
    
      .message {
        margin-top: 10px;
      }
    
      .buttonContainer {
        margin-top: 32px;
        margin-bottom: 20px;
        display: flex;
        justify-content: center; /* Center the child elements horizontally */
        align-items: center;
      }

      .icon{
        display: flex;
        justify-content: center; /* Center the child elements horizontally */
        align-items: center;
      }
  `
  }

  eventListeners: EventListeners = [
    ['[name=primaryButton]', 'click', this.onClickPrimaryButton.bind(this)],
  ]
}
